import {
  Component,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';

import { Attachment } from '@ui/shared/model';

@Component({
  selector: 'app-attachment-preview-v2',
  templateUrl: './attachment-preview-v2.component.html',
  styleUrls: ['./attachment-preview-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class AttachmentPreviewV2Component {
  public readonly imgSrc = input<string>(undefined);
  public readonly isDocument = input(false);
  public readonly attachment = input<Attachment>(undefined);

  public readonly preview = output<Attachment>();
  public readonly download = output<Attachment>();

  public previewOpen = false;

  public togglePreview() {
    this.previewOpen = !this.previewOpen;
  }

  public openPreview() {
    this.previewOpen = true;
  }

  public closePreview() {
    this.previewOpen = false;
  }

  public isPdf(attachment: Attachment) {
    return (
      attachment.type === 'PDF' ||
      (attachment.title && attachment.title.toLowerCase().endsWith('.pdf'))
    );
  }

  public clickOnPdf() {
    const attachment = this.attachment();
    if (attachment.url) {
      this.preview.emit(attachment);
    }
  }

  public clickOnImage() {
    const attachment = this.attachment();
    if (attachment.url) {
      this.download.emit(attachment);
    }
  }
}
